import { format } from "date-fns";

export function SetPayrollPeriodId(payrollPeriodId) {
	const formattedDateFrom = format(payrollPeriodId.dateFrom, "MM/dd/yyyy");
	const formattedDateTo = format(payrollPeriodId.dateTo, "MM/dd/yyyy");

	return (
		<option value={payrollPeriodId.id}>
			{`${formattedDateFrom} - ${formattedDateTo} ${payrollPeriodId.payTypeDescription
				? payrollPeriodId.payTypeDescription
				: ""
				}`}
		</option>
	);
}